// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FaqSection-eh-faq-scEfM {
  width: 100%;
  background: #ffffff;
  padding: 40px 24px 64px;
}

.FaqSection-eh-faq__container-QXcZR {
  max-width: 840px;
  margin: 0 auto;
}

.FaqSection-eh-faq__heading-Ahd9q {
  font-size: 40px;
  font-weight: bold;
  color: var(--secondary-oscuro);
  text-align: center;
  margin: 0 0 36px 0;
}

.FaqSection-eh-faq__list-l8Cvz {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  border-top: 1px solid var(--secondary-oscuro);
}

.FaqSection-eh-faq__item-k4cZw {
  border-bottom: 1px solid var(--secondary-oscuro);
}

.FaqSection-eh-faq__question-uptxe {
  width: 100%;
  background: transparent;
  border: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  padding: 22px 8px;
  cursor: pointer;
  text-align: left;
  gap: 16px;
  -webkit-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
}

.FaqSection-eh-faq__question-uptxe:hover {
  opacity: 0.8;
}

.FaqSection-eh-faq__question-text-EYt2X {
  font-size: 30px;
  font-weight: normal;
  color: var(--secondary-oscuro);
}

.FaqSection-eh-chevron-container-GIJ3e {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  color: var(--secondary-oscuro);
  -ms-flex-negative: 0;
      flex-shrink: 0;
  -webkit-transition: -webkit-transform 0.25s ease;
  transition: -webkit-transform 0.25s ease;
  transition: transform 0.25s ease;
  transition: transform 0.25s ease, -webkit-transform 0.25s ease;
}

.FaqSection-eh-chevron-container--open-LtucG {
  -webkit-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
          transform: rotate(180deg);
}

.FaqSection-eh-faq__answer-m6gWX {
  max-height: 0;
  overflow: hidden;
  -webkit-transition: max-height 0.3s ease, padding 0.3s ease;
  transition: max-height 0.3s ease, padding 0.3s ease;
  padding: 0 8px;
}

.FaqSection-eh-faq__answer--open-Tw_hK {
  max-height: 300px;
  padding: 0 8px 22px;
}

.FaqSection-eh-faq__answer-m6gWX p {
  margin: 0;
  font-size: 20px;
  line-height: 1.6;
  color: var(--secondary-oscuro);
}

@media (max-width: 768px) {
  .FaqSection-eh-faq__heading-Ahd9q {
    font-size: 26px;
    margin-bottom: 24px;
  }
  .FaqSection-eh-faq__question-text-EYt2X {
    font-size: 16px;
  }
  .FaqSection-eh-faq__question-uptxe {
    padding: 18px 4px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/WhyhostView/FaqSection.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,qCAA6B;EAA7B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAc;MAAd,cAAc;EACd,gDAAgC;EAAhC,wCAAgC;EAAhC,gCAAgC;EAAhC,8DAAgC;AAClC;;AAEA;EACE,iCAAyB;MAAzB,6BAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,2DAAmD;EAAnD,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".eh-faq {\n  width: 100%;\n  background: #ffffff;\n  padding: 40px 24px 64px;\n}\n\n.eh-faq__container {\n  max-width: 840px;\n  margin: 0 auto;\n}\n\n.eh-faq__heading {\n  font-size: 40px;\n  font-weight: bold;\n  color: var(--secondary-oscuro);\n  text-align: center;\n  margin: 0 0 36px 0;\n}\n\n.eh-faq__list {\n  display: flex;\n  flex-direction: column;\n  border-top: 1px solid var(--secondary-oscuro);\n}\n\n.eh-faq__item {\n  border-bottom: 1px solid var(--secondary-oscuro);\n}\n\n.eh-faq__question {\n  width: 100%;\n  background: transparent;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 22px 8px;\n  cursor: pointer;\n  text-align: left;\n  gap: 16px;\n  transition: opacity 0.2s ease;\n}\n\n.eh-faq__question:hover {\n  opacity: 0.8;\n}\n\n.eh-faq__question-text {\n  font-size: 30px;\n  font-weight: normal;\n  color: var(--secondary-oscuro);\n}\n\n.eh-chevron-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--secondary-oscuro);\n  flex-shrink: 0;\n  transition: transform 0.25s ease;\n}\n\n.eh-chevron-container--open {\n  transform: rotate(180deg);\n}\n\n.eh-faq__answer {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease, padding 0.3s ease;\n  padding: 0 8px;\n}\n\n.eh-faq__answer--open {\n  max-height: 300px;\n  padding: 0 8px 22px;\n}\n\n.eh-faq__answer p {\n  margin: 0;\n  font-size: 20px;\n  line-height: 1.6;\n  color: var(--secondary-oscuro);\n}\n\n@media (max-width: 768px) {\n  .eh-faq__heading {\n    font-size: 26px;\n    margin-bottom: 24px;\n  }\n  .eh-faq__question-text {\n    font-size: 16px;\n  }\n  .eh-faq__question {\n    padding: 18px 4px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eh-faq": `FaqSection-eh-faq-scEfM`,
	"eh-faq__container": `FaqSection-eh-faq__container-QXcZR`,
	"eh-faq__heading": `FaqSection-eh-faq__heading-Ahd9q`,
	"eh-faq__list": `FaqSection-eh-faq__list-l8Cvz`,
	"eh-faq__item": `FaqSection-eh-faq__item-k4cZw`,
	"eh-faq__question": `FaqSection-eh-faq__question-uptxe`,
	"eh-faq__question-text": `FaqSection-eh-faq__question-text-EYt2X`,
	"eh-chevron-container": `FaqSection-eh-chevron-container-GIJ3e`,
	"eh-chevron-container--open": `FaqSection-eh-chevron-container--open-LtucG`,
	"eh-faq__answer": `FaqSection-eh-faq__answer-m6gWX`,
	"eh-faq__answer--open": `FaqSection-eh-faq__answer--open-Tw_hK`
};
module.exports = ___CSS_LOADER_EXPORT___;
